/* eslint import/first: 0 */
import doggingPage from 'Dogging';
import site from 'Site/site';

site();
doggingPage();
